import { Data, DataValueType } from "../types"

export const validateNumberLength = (length: number, value?: DataValueType): string | null => {
    return value && !(new RegExp(`^\\d{${length}}$`).test(value?.toString())) ?
        `El valor debe contener ${length} dígitos numéricos.` :
        null
}

export const validateIdentifier = (data: Data): string | null => {
    const value = data.identifier?.toString()
    return value && !/^\d{7,8}$/.test(value) ? 'El valor debe contener 7 u 8 dígitos numéricos.' : null
}

export const validateTaxId = (data: Data): string | null => validateNumberLength(11, data.taxId)

export const validateEmail = (data: Data): string | null => {
    const value = data.email?.toString()
    return value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? 'El valor debe ser un email válido.' : null
}

export const validatePhone = (data: Data): string | null => {
    const value = data.phone?.toString()
    return value && !/^\d{8,15}$/.test(value) ? 'El valor debe contener de 8 a 15 dígitos numéricos.' : null
}

export const validatePlate = (data: Data): string | null => {
    const value = data.plate?.toString()
    return value && !/^[a-zA-Z0-9]{6,7}$/.test(value) ? 'El valor debe contener 6 o 7 caracteres y sólo puede contener letras o números.' : null
}
